import { createApi, retry } from "@reduxjs/toolkit/query/react"
import { axiosBaseQuery } from "@/api/service"

const baseQuery = axiosBaseQuery()

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 0 })

export enum TAGS {
  AUTH = "AUTH",
  PLAYER = "PLAYER",
  WORLD_MAP = "WORLD_MAP",
  PLAYER_POSITION = "PLAYER_POSITION",
  SECTOR_DETAILS = "SECTOR_DETAILS",
  MOVEMENT = "MOVEMENT",
  INVENTORY = "INVENTORY",
  HERO = "HERO",
  MOBS_CELL = "MOBS_CELL",
  MOB_ENGAGEMENT = "MOB_ENGAGEMENT",
  WALLET = "WALLET",
  BATTLE = "BATTLE"
}

export const api = createApi({
  reducerPath: "splitApi",
  baseQuery: baseQueryWithRetry,
  refetchOnFocus: false,
  endpoints: () => ({})
})
